import React from 'react'
import {Box, Typography} from '@material-ui/core'
import MuiExpansionPanel from '@material-ui/core/Accordion'
import MuiExpansionPanelSummary from '@material-ui/core/AccordionSummary'
import MuiExpansionPanelDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import {withStyles, makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    paper: {
        position: 'absolute',
        top: 48,
        right: 40,
        borderRadius: '0px',
        width: '460px',
        maxHeight: '80vh',
        overflow: 'auto',
        whiteSpace: 'normal',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '320px',
            maxHeight: '75vh',
            right: 0,
        },
    },
    circle: {
        boxSizing: 'border-box',
        borderRadius: '50%',
        backgroundColor: theme.palette.common.white,
        height: '38px',
        width: '38px',
        padding: '1px 1px 1px 1px',
        '&:hover': {
            opacity: 0.8,
            backgroundColor: theme.palette.common.white,
            transition: 'border-color 0.2s, border-width 0.2s',
        },
    },
    helpsubheader: {
        fontWeight: theme.typography.body1.bold.fontWeight,
    },
    text: {
        alignItems: 'flex-start',
        font: 'Regular 0.8125rem/1.1875rem Montserrat',
        letterSpacing: 0,
        color: '#262626',
        opacity: 1,
    },
}))

const ExpansionPanel = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiExpansionPanel)

const ExpansionPanelSummary = withStyles(theme => ({
    root: {
        backgroundColor: theme.palette.common.white,
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: '3.5rem',
        '&$expanded': {
            backgroundColor: theme.palette.grey.pale,
            minHeight: '3.5rem',
        },
    },
    content: {
        '&$expanded': {
            margin: '0.75rem 0',
        },
    },
    expanded: {},
}))(MuiExpansionPanelSummary)

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiExpansionPanelDetails)

const HelpContentDeptCreator = props => {
    const classes = useStyles()

    const {expanded, handleChange} = props

    return (
        <>
            <ExpansionPanel
                square
                expanded={expanded === 'panel4'}
                onChange={handleChange('panel4')}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography variant="subtitle1">
                        How to Setup Events
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <div className={classes.text}>
                            <ol>
                                <li>Go to the Event Setup tab.</li>
                                <li>
                                    Select an existing event category or create
                                    a new one by clicking “Create Category” in
                                    the drawer on the left.
                                </li>
                                <li>
                                    Once a category is selected, you can create
                                    an event occurrence by clicking “Create
                                    Event” in the table on the right.
                                </li>
                                <li>
                                    Fill out the Create Event Occurrence form,
                                    add swipers, and click “Create Occurrence”
                                    to save it.
                                </li>
                                <li>
                                    Event occurrences you create will appear in
                                    the Swiping tab to assigned swipers when the
                                    current date falls within the date range you
                                    set for the event.
                                </li>
                            </ol>
                        </div>
                    </Box>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
                square
                expanded={expanded === 'panel5'}
                onChange={handleChange('panel5')}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5bh-content"
                    id="panel5bh-header"
                >
                    <Typography variant="subtitle1">
                        How to Create Swipe Teams
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <div className={classes.text}>
                            <ol>
                                <li>
                                    Click {'"Swipe Teams"'} under the Event
                                    Setup tab.
                                </li>
                                <li>Click {'"Create Swipe Team"'}.</li>
                                <li>
                                    Add swipers by EUID, ID Number, or Name
                                    Lookup.
                                </li>
                                <li>
                                    Click {'“Create Swipe Team”'} to save the
                                    team.
                                </li>
                                <li>
                                    Your teams will appear in the Swipe Teams
                                    drop-down when creating and editing event
                                    occurrences.
                                </li>
                            </ol>
                        </div>
                    </Box>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
                square
                expanded={expanded === 'panel6'}
                onChange={handleChange('panel6')}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel6bh-content"
                    id="panel6bh-header"
                >
                    <Typography variant="subtitle1">
                        How to Manage Events
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            Event Categories
                        </Typography>
                        <div className={classes.text}>
                            <ul>
                                <li>
                                    Edit a category by selecting it and clicking
                                    the pencil icon.
                                </li>
                                <li>
                                    Delete an event category by selecting
                                    “Delete” in the editing screen. You cannot
                                    delete categories that contain event
                                    occurrences that have swipes recorded to
                                    them.
                                </li>
                                <li>
                                    Archive an event category by selecting
                                    “Archive” in the editing screen.
                                </li>
                                <li>
                                    Click “View Archived Categories” in the
                                    bottom of the category drawer to view and
                                    Re-Activate archived categories.
                                </li>
                            </ul>
                        </div>

                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            Event Occurrences
                        </Typography>
                        <div className={classes.text}>
                            <ul>
                                <li>
                                    Click on an event occurrence to edit it.
                                </li>
                                <li>
                                    Move an event occurrence between categories
                                    in the editing screen by changing the event
                                    category in the drop-down at the top. You
                                    cannot move occurrences that have swipes
                                    recorded to them.
                                </li>
                                <li>
                                    Clone an event occurrence by clicking the
                                    page icon next to it in the table. Cloning
                                    will copy event details into a new form, but
                                    will not copy over swipe data.
                                </li>
                                <li>
                                    Delete an event occurrence by clicking on
                                    the checkbox next to it and selecting the
                                    trash can that appears at the top. You
                                    cannot delete occurrences that have swipes
                                    recorded to them.
                                </li>
                            </ul>
                        </div>
                    </Box>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
                square
                expanded={expanded === 'panel7'}
                onChange={handleChange('panel7')}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel7bh-content"
                    id="panel7bh-header"
                >
                    <Typography variant="subtitle1">Event Setup FAQ</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            What’s the difference between active and inactive
                            events?
                        </Typography>
                        <Typography variant="body2" align="left" paragraph>
                            An event is considered active when the current date
                            falls within the date range set for the occurrence,
                            and inactive when it does not. Active events appear
                            in the Swiping tab to all assigned swipers, inactive
                            events do not.
                        </Typography>

                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            What happens when I limit my events to students
                            only?
                        </Typography>
                        <Typography variant="body2" align="left" paragraph>
                            Limiting your events to certain groups will
                            automatically deny swipe attempts from attendees
                            that do not meet the criteria of that group.
                        </Typography>
                        <div className={classes.text}>
                            <ul>
                                <li>
                                    Students Only will deny swipes from anyone
                                    that’s not enrolled in the semester the
                                    swipe is taking place.
                                </li>
                                <li>
                                    Employees Only will deny swipes from anyone
                                    not employed at UNT when the swipe is taking
                                    place.
                                </li>
                                <li>
                                    Everyone at UNT will accept swipes from
                                    anyone with a valid EUID, ID Number or ID
                                    card; this includes alumni or retired
                                    employees.
                                </li>
                            </ul>
                        </div>

                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            What are engagement types?
                        </Typography>
                        <Typography variant="body2" align="left" paragraph>
                            Engagement types allow the University to group
                            events and services across departments into like
                            themes for analytics. It’s not required, but helpful
                            to select one.
                        </Typography>

                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            What happens when I deny duplicate swipes?
                        </Typography>
                        <Typography variant="body2" align="left" paragraph>
                            You can configure your events to automatically deny
                            multiple swipe attempts from the same attendee.
                        </Typography>
                        <div className={classes.text}>
                            <ul>
                                <li>
                                    You can deny duplicate swipes for the entire
                                    time the event is active by selecting deny.
                                </li>
                                <li>
                                    You can also deny swipes for a shorter
                                    duration, including 5 minutes, 1 hour, and
                                    12 hours. This will prevent the same
                                    attendee from swiping into your event again
                                    until after the designated duration has
                                    passed.
                                </li>
                            </ul>
                        </div>

                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            How do swipe teams work?
                        </Typography>
                        <Typography variant="body2" align="left" paragraph>
                            Swipe teams are a way to quickly assign multiple
                            swipers to your event. You can have the same swiper
                            in multiple teams, and you can add multiple swipe
                            teams to the same event. Adding or removing swipers
                            from a swipe team will not change the swipers
                            assigned to existing event occurrences.
                        </Typography>
                    </Box>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </>
    )
}

export default HelpContentDeptCreator
